export const API_KEY = '&api_key=5a87187be1c22d94b6425dc7c7dec67f';
export const URL_ALBUM_SEARCH = 'https://ws.audioscrobbler.com/2.0/?method=album.search&limit=10&format=json&album=';
